<div class="container" [ngSwitch]="mode">
  <div *ngSwitchDefault>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width: 100%">
      <tr class="back">
        <th>Ref Dr Code</th>
        <th>Name</th>
        <th>
          <button
            class="add"
            mat-raised-button
            color="basic"
            (click)="addNew()"
            *ngIf="
              role !== 'Front Desk' ||
              role == 'Account' ||
              role == 'Marketer' ||
              canDiscount.length > 0
            "
          >
            Add New
          </button>
        </th>
        <th>
          <input
            type="text"
            class="form-control"
            id="search-text"
            aria-describedby="search-text"
            [(ngModel)]="searchText"
            placeholder="Search"
            autofocus
          />
        </th>
      </tr>
      <tr class="td" *ngFor="let title of filterddata">
        <td>{{ title.ref_doctor_code }}</td>
        <td>{{ title.Acount_Name }}</td>
        <td>{{ title.Status }}</td>
        <td>
          <button mat-raised-button color="primary" (click)="edit(title)">
            Edit
          </button>
          <button
            mat-raised-button
            color="primary"
            style="margin-left: 5px"
            (click)="delete(title)"
            *ngIf="role !== 'Front Desk'"
          >
            Delete
          </button>
        </td>
      </tr>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
        <p>{{ Errors }}</p>
      </div>
    </div>
    <div class="last"></div>
  </div>
  <form
    [formGroup]="stateForm"
    (ngSubmit)="onSubmit($event)"
    class="post"
    *ngSwitchCase="'add'"
  >
    <div class="post">
      <div class="title">Create Referral Doctor</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="Acount_Name" matInput placeholder="" />
          </mat-form-field>
        </span>
        <!-- <span class="input">
            <mat-form-field>
                <mat-label>Account Name</mat-label>
                <input formControlName="name" matInput placeholder="">
              </mat-form-field>
          </span> -->
        <span class="input">
          <mat-form-field>
            <mat-label>Specialization</mat-label>
            <mat-select formControlName="specialisation_code" matNativeControl>
              <mat-option
                *ngFor="let spec of specializations"
                [value]="spec.Spec_Id"
              >
                {{ spec.Spec_Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Address 1</mat-label>
            <input formControlName="address1" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Address 2</mat-label>
            <input formControlName="address2" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>City</mat-label>
            <mat-select formControlName="city" matNativeControl>
              <mat-option *ngFor="let city of cities" [value]="city.id">
                {{ city.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Country</mat-label>
            <mat-select formControlName="Country" matNativeControl>
              <mat-option
                *ngFor="let country of countries"
                [value]="country.id"
              >
                {{ country.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <!-- <span class="input">
            <mat-form-field>
                <mat-label>Residence No.</mat-label>
                <input formControlName="area" matInput placeholder="">
              </mat-form-field>
          </span> -->
        <!-- <span class="input">
            <mat-form-field>
                <mat-label>Office No.</mat-label>
                <input formControlName="name" matInput placeholder="">
              </mat-form-field>
          </span> -->
        <span class="input">
          <mat-form-field>
            <mat-label>Mobile No.</mat-label>
            <input formControlName="mobile" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input formControlName="email" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Share Amount</mat-label>
            <input
              formControlName="Share_per"
              type="number"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Account No.</mat-label>
            <input formControlName="Account_No" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Bank Name</mat-label>
            <mat-select formControlName="Bank_Name" matNativeControl>
              <mat-option *ngFor="let bank of banks" [value]="bank.name">
                {{ bank.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Hospital Nmae</mat-label>
            <input formControlName="Hospital_Name" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="Status" matNativeControl>
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Inactive">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Username</mat-label>
            <input formControlName="U_Name" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Password</mat-label>
            <input formControlName="Password" matInput placeholder="" />
          </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
  <form
    [formGroup]="stateForm"
    (ngSubmit)="onSubmit($event)"
    class="post"
    *ngSwitchCase="'edit'"
  >
    <div class="post">
      <div class="title">Edit Ref Doctor</div>
      <div class="form">
        <span class="input">
          <mat-form-field>
            <mat-label>Name</mat-label>
            <input formControlName="Acount_Name" matInput placeholder="" />
          </mat-form-field>
        </span>
        <!-- <span class="input">
            <mat-form-field>
                <mat-label>Account Name</mat-label>
                <input formControlName="name" matInput placeholder="">
              </mat-form-field>
          </span> -->
        <span class="input">
          <mat-form-field>
            <mat-label>Specialization</mat-label>
            <mat-select formControlName="specialisation_code" matNativeControl>
              <mat-option
                *ngFor="let spec of specializations"
                [value]="spec.Spec_Id"
              >
                {{ spec.Spec_Name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Address 1</mat-label>
            <input formControlName="address1" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Address 2</mat-label>
            <input formControlName="address2" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>City</mat-label>
            <mat-select formControlName="city" matNativeControl>
              <mat-option *ngFor="let city of cities" [value]="city.id">
                {{ city.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Country</mat-label>
            <mat-select formControlName="Country" matNativeControl>
              <mat-option
                *ngFor="let country of countries"
                [value]="country.id"
              >
                {{ country.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <!-- <span class="input">
            <mat-form-field>
                <mat-label>Residence No.</mat-label>
                <input formControlName="area" matInput placeholder="">
              </mat-form-field>
          </span> -->
        <!-- <span class="input">
            <mat-form-field>
                <mat-label>Office No.</mat-label>
                <input formControlName="name" matInput placeholder="">
              </mat-form-field>
          </span> -->
        <span class="input">
          <mat-form-field>
            <mat-label>Mobile No.</mat-label>
            <input formControlName="mobile" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Email</mat-label>
            <input formControlName="email" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Share Amount</mat-label>
            <input
              formControlName="Share_per"
              type="number"
              matInput
              placeholder=""
            />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Account No.</mat-label>
            <input formControlName="Account_No" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Bank Name</mat-label>
            <mat-select formControlName="Bank_Name" matNativeControl>
              <mat-option *ngFor="let bank of banks" [value]="bank.name">
                {{ bank.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Hospital Nmae</mat-label>
            <input formControlName="Hospital_Name" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Status</mat-label>
            <mat-select formControlName="Status" matNativeControl>
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Inactive">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Username</mat-label>
            <input formControlName="U_Name" matInput placeholder="" />
          </mat-form-field>
        </span>
        <span class="input">
          <mat-form-field>
            <mat-label>Password</mat-label>
            <input formControlName="Password" matInput placeholder="" />
          </mat-form-field>
        </span>
      </div>
      <div class="errorMessage">
        <div *ngIf="Errors" class="error">
          <p>{{ Errors }}</p>
        </div>
      </div>
      <div class="errorMessage">
        <div *ngIf="Success" class="Success">
          <p>Saved Succesfully</p>
        </div>
      </div>
      <div class="but">
        <button class="create" mat-raised-button color="primary">
          {{ isLoading ? "Saving..." : "Save" }}
        </button>
      </div>
    </div>
  </form>
</div>
